module.exports = __webpack_public_path__ + "media/images/stock-children2-da334fb9.jpg";